module.exports = __webpack_public_path__ + "media/10_ASANBUDAPEST-BASS10.a846d0db.mp3";